import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { capitalize } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/utils';
import { useDebugState } from 'Context/DebugContext';
import Box from './index';

export const DEBUG_COLORS = [
  'chartreuse',
  'deepPink',
  'dodgerBlue',
  'coral',
  'crimson',
  'gold',
  'lightSeaGreen',
  'none',
];

const styles = () => ({
  root: {},
});

const getRootDebugBackgroundColor = (backgroundColor) => {
  return {
    backgroundColor,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootDebugBackgroundColorChartreuse: getRootDebugBackgroundColor(theme.palette.debug.chartreuse),
  rootDebugBackgroundColorDeepPink: getRootDebugBackgroundColor(theme.palette.debug.deepPink),
  rootDebugBackgroundColorDodgerBlue: getRootDebugBackgroundColor(theme.palette.debug.dodgerBlue),
  rootDebugBackgroundColorCoral: getRootDebugBackgroundColor(theme.palette.debug.coral),
  rootDebugBackgroundColorCrimson: getRootDebugBackgroundColor(theme.palette.debug.crimson),
  rootDebugBackgroundColorGold: getRootDebugBackgroundColor(theme.palette.debug.gold),
  rootDebugBackgroundColorLightSeaGreen: getRootDebugBackgroundColor(theme.palette.debug.lightSeaGreen),
  rootDebugBackgroundColorNone: {},
}));

const DebugBox = ({
  className,
  classes,
  debugColor,
  ...rest
}) => {
  const debugState = useDebugState();
  const customClasses = useCustomStyles();

  return (
    <Box
      className={classNames(classes.root, className, {
        [customClasses[`rootDebugBackgroundColor${capitalize(debugColor)}`]]: debugState.showDebugColors,
      })}
      {...rest}
    />
  );
};

DebugBox.defaultProps = {
  className: '',
  debugColor: 'none',
};

DebugBox.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  debugColor: PropTypes.oneOf(DEBUG_COLORS),
};

export default withStyles(styles)(DebugBox);
